import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { ChangeLanguageService } from './change-language.service';

@Injectable()
export class CustomerInfoDataService extends BaseService<any>{
  
  constructor(public httpClient: HttpClient, private languageService: ChangeLanguageService) {
      super('authentication', httpClient);
  }

  getCustomerInfoData(uuid: string, uuid2: string):  Observable<any[]> {
        
    let uri = new URL(environment.baseUrl + `/public/customer/info/${uuid}/ ${uuid2}/ ${this.languageService.getCurrentLanguage()}`);
    
    return this.httpClient.get<any>(uri.toString(),  { withCredentials: false, headers:  this.httpHeaders() })
        .pipe(
            tap(),
            catchError(this.handleError)
        )
  }
  postCustomerInfoData(uuid: string, uuid2: string, customerInfoData: any):  Observable<any[]> {
        
    let uri = new URL(environment.baseUrl + `/public/customer/info/${uuid}/ ${uuid2}/ ${this.languageService.getCurrentLanguage()}`);
    
    return this.httpClient.post<any>(uri.toString(), customerInfoData, { withCredentials: false, headers:  this.httpHeaders() })
        .pipe(
            tap(),
            catchError(this.handleError)
        )
  }

 

}
